import {defineStore, storeToRefs} from "pinia";
import {computed} from "vue";
import {OrderAttributesValue, VorderCurrent, VorderInput} from "@/gql/gen";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useUtmStore} from "@/modules/marketing/store/utm";
import cloneDeep from "lodash-es/cloneDeep";

const STORE_NAME = 'vorder-api'

export const useVorderApi = defineStore(STORE_NAME, () => {

    // COMPUTED

    const vorderState = useVorderState()
    const basketStore = useBasketStore();

    const {
        vorderId,
        attrs,
        attrsPrev,
        attrsInfo,
        paymentTypes,
        transportTypes,
        vorderSynced,
        deliveries,
        coupon,
        orderRestrictions,
        orderOffice,
        deliveryPriceRules,
    } = storeToRefs(vorderState);


    const vorderInput = computed(() => {
        const res: VorderInput = {}
        const utmAttrs = useUtmStore().getOrderAttrs()

        res.attrs = {
            ...vorderState.attrs,
            ...(utmAttrs ?? {}),
        } as OrderAttributesValue
        res.basket = basketStore.items.map((item) => item.getApiData())
        res.vorderId = vorderId.value
        return res
    })

    function updateVorderFromServer(data: VorderCurrent) {

        deliveries.value = data.DELIVERIES;
        paymentTypes.value = data.PAYMENT_TYPES;
        transportTypes.value = data.TRANSPORT_TYPES;
        deliveryPriceRules.value = data.DELIVERY_PRICE_RULES

        let result = false

        console.log('storage vorderId', vorderId.value)
        console.log('server vorderId', data.ID)

        if (vorderId.value !== data.ID) {
            vorderId.value = data.ID

            attrs.value = data.ATTR;
            attrsPrev.value = cloneDeep(data.ATTR);

            if (data.ATTRS)
                attrsInfo.value = data.ATTRS;

            coupon.value = data.COUPONS[0];

            basketStore.fillBasket([])
            result = true
        } else {
            basketStore.fillBasket(basketStore.itemsSource)
        }

        vorderSynced.value = true
        return result
    }

    return {
        vorderInput,
        updateVorderFromServer
    }
})

